export const learningCenterEventNames = {
    viewLearningCenter: 'View Learning Center',
    goalProgressStatus: 'Goal Progress Status',
    levelProgressStatus: 'Level Progress Status',
    moduleProgressStatus: 'Module Progress Status',
    lessonProgressStatus: 'Lesson Progress Status',
    quizAttemptStatus: 'Quiz Attempt Status'
}
